import React from 'react'

import './LoadingIndicator.css'

export default () => (
  <svg viewBox="0 0 36 36" className="loading-indicator">
    <use xlinkHref="#loading-indicator" />
  </svg>
)
